// module factories are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/react-hot-loader/patch.js");
__webpack_require__("./node_modules/webpack-hot-middleware/client.js?name=dashboard&reload=true");
var __webpack_exports__ = __webpack_require__("./client/entrypoints/dashboard/index.js");
